<template>
  <div class="ant-pro-global-header-index-right">
    <a-dropdown
      v-model="message.visible"
      :trigger="['click']"
    >
      <a class="ant-dropdown-link"
         style="margin-right: 20px;height: 64px;display: inline-block;"
         @click="e => e.preventDefault()">
        <a-badge :count="count">
          <a-icon style="font-size: 25px;vertical-align: middle;" type="mail"/>
        </a-badge>
      </a>
      <a-card
        slot="overlay"
        :tab-list="tabListNoTitle"
        :active-tab-key="noTitleKey"
        @tabChange="key => onTabChange(key, 'noTitleKey')"
      >
        <p v-if="noTitleKey === 'article'">
          <a-list item-layout="horizontal" :data-source="tempData.warnData">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta
                :description="item.description">
                <a slot="title" @click="jumpWarn">{{ item.title }}</a>
                <a-avatar
                  slot="avatar"
                  src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </p>
        <p v-else-if="noTitleKey === 'app'">
          <a-list item-layout="horizontal" :data-source="tempData.insideData">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <a slot="title" @click="jumpInside">{{ item.title }}</a>
                <a-avatar
                  slot="avatar"
                  src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </p>
        <p v-else="noTitleKey === 'project'">
          <a-list item-layout="horizontal" :data-source="tempData.reminder">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <a slot="title" @click="jumpReminder">{{ item.title }}</a>
                <a-avatar
                  slot="avatar"
                  src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </p>
      </a-card>
    </a-dropdown>
    <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls"/>
    <!--    <select-lang :class="prefixCls"/>-->
  </div>
</template>

<script>
import SelectLang from '@/components/SelectLang/SelectLang.vue';
import AvatarDropdown from './AvatarDropdown.vue';
import {getSimpleInsideData, getSimpleWarning, getSimpleReminder} from '../../api/insideDeal'

async function getInsideDeal() {
  let _this = this;
  const result = await getSimpleInsideData();
  if (result.code === 1200) {
    let data = result.data.tableData;
    _this.count += result.data.total;
    let length = data.length > 3 ? 3 : data.length
    for (let i = 0; i < length; i++) {
      _this.$set(_this.tempData.insideData, i, { "title": data[i].order.customerName })
    }
  }
}

async function getWarning() {
  let _this = this;
  const result = await getSimpleWarning();
  if (result.code === 1200) {
    let data = result.data.tableData;
    _this.count += result.data.total;
    let length = data.length > 3 ? 3 : data.length
    for (let i = 0; i < length; i++) {
      _this.$set(_this.tempData.warnData, i, {
        "title": data[i].customerName,
        "description": "ifsNo:" + data[i].ifsNo + "\n" + "orderNo: " + data[i].orderNo
      })
    }
  }
}

async function getReminder() {
  let _this = this;
  const result = await getSimpleReminder();
  if (result.code === 1200) {
    let data = result.data.tableData;
    this.count += result.data.total;
    let length = data.length > 3 ? 3 : data.length
    for (let i = 0; i < length; i++) {
      _this.$set(_this.tempData.reminder, i, { "title": data[i].order.customerName })
    }
  }
}

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    SelectLang,
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
  },
  data() {
    return {
      showMenu: true,
      currentUser: {},
      message: {
        visible: false,
      },
      count: 0,
      tempData: {
        insideData: [],
        warnData: [],
        reminder: []
        // {
        //   title: 'Ant Design Title 1',
        // },
        // {
        //   title: 'Ant Design Title 2',
        // },
        // {
        //   title: 'Ant Design Title 3',
        // },
        // {
        //   title: 'Ant Design Title 4',
        // },
      },
      tabList: [
        {
          key: 'tab1',
          // tab: 'tab1',
          scopedSlots: { tab: 'customRender' },
        },
        {
          key: 'tab2',
          tab: 'tab2',
        },
      ],
      contentList: {
        tab1: 'content1',
        tab2: 'content2',
      },
      tabListNoTitle: [
        {
          key: 'article',
          tab: '预警',
        },
        {
          key: 'app',
          tab: '内部',
        },
        {
          key: 'project',
          tab: '催单',
        },
      ],
      key: 'tab1',
      noTitleKey: 'app',
    };
  },
  methods: {
    onTabChange(key, type) {
      this[type] = key;
      // if (key === 'article ') {
      // } else if (key === 'app') {
      //
      // } else {
      //
      // }
    },
    getInsideDeal,
    getWarning,
    getReminder,
    jumpInside() {
      this.$router.push("/insideDeal")
    },
    jumpWarn() {
      this.$router.push("/warning")
    },
    jumpReminder() {
      this.$router.push("/reminder")
    }
  },
  computed: {
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${ (this.isMobile || !this.topMenu) ? 'light' : this.theme }`]: true,
      };
    },
  },
  mounted() {
    this.getInsideDeal()
    this.getWarning()
    this.getReminder()
    setTimeout(() => {
      this.currentUser = {
        name: 'Serati Ma',
      };
    }, 1500);
  },
};
</script>
<style lang="less">
  @import "~ant-design-vue/es/style/themes/default.less";

  .ant-pro-global-header-index-right {
    margin-right: 8px;
    float: right;

    &.ant-pro-global-header-index-dark {
      .ant-pro-global-header-index-action {
        color: hsla(0, 0%, 100%, .85);

        &:hover {
          background: #1890ff;
        }
      }
    }

    .ant-pro-account-avatar {
      cursor: pointer;
      .antd-pro-global-header-index-avatar {
        margin: ~'calc((@{layout-header-height} - 24px) / 2)' 0;
        margin-right: 8px;
        color: @primary-color;
        vertical-align: top;
        background: rgba(255, 255, 255, 0.85);
      }
    }

    .menu {
      .anticon {
        margin-right: 8px;
      }

      .ant-dropdown-menu-item {
        min-width: 100px;
      }
    }
  }

</style>
